
import props from './props'

const defaultProps = props.reduce((defaultProps, propItem) => {
  const { name, defaultValue } = propItem
  defaultProps[name] = defaultValue
  return defaultProps
}, {})

export const propTypeMap = props.reduce((mapObj, propItem) => {
  const { name, type } = propItem
  mapObj[name] = type
  return mapObj
}, {})

export const unitMap = props.reduce((mapObj, propItem) => {
  const { name, unit } = propItem
  mapObj[name] = unit
  return mapObj
}, {})


export default defaultProps

  
